<template>
  <el-row class="full-container header g_header" v-if="!yunModel">
    <div class="main-container">
      <el-col :span="3" class="item">
        <router-link to="/" class="logo"></router-link>
      </el-col>
      <el-col :span="14" class="v3-header-menu">
        <div class="menu-item-container">
          <div :class="activePath == '' ? 'menu-item active' : 'menu-item'">
            <router-link to="/"
              ><span>{{ $t("header.menu.home") }}</span></router-link
            >
          </div>
        </div>
        <div class="menu-item-container">
          <div
            :class="
              activity.includes(activePath) || pathname == '/product/query'
                ? 'menu-item active'
                : 'menu-item'
            "
          >
            <router-link :to="{ name: 'ProductQueryPage' }">
              <span class="el-dropdown-link area ">{{
                $t("header.menu.product")
              }}</span>
            </router-link>
          </div>
        </div>
        <div class="menu-item-container">
          <div
            :class="
              tool.includes(activePath) ? 'menu-item active' : 'menu-item'
            "
          >
            <el-dropdown placement="bottom">
              <span class="el-dropdown-link area ">
                {{ $t("header.menu.tool") }}
              </span>
              <el-dropdown-menu slot="dropdown" class="tc">
                <router-link to="/tool/airport_code">
                  <el-dropdown-item command="机场三字码">{{
                    $t("header.menu.airportCode")
                  }}</el-dropdown-item>
                </router-link>
                <router-link to="/tool/hs_code">
                  <el-dropdown-item command="HS编码">{{
                    $t("header.menu.hs")
                  }}</el-dropdown-item>
                </router-link>
                <router-link to="/tool/tact">
                  <el-dropdown-item command="TACT查询">{{
                    $t("header.menu.tact")
                  }}</el-dropdown-item>
                </router-link>
                <router-link to="/tool/airline_info">
                  <el-dropdown-item command="航司信息">{{
                    $t("header.menu.airlineInfo")
                  }}</el-dropdown-item>
                </router-link>
                <router-link to="/tool/plane_type">
                  <el-dropdown-item command="飞机机型">{{
                    $t("header.menu.planeType")
                  }}</el-dropdown-item>
                </router-link>
                <router-link :to="{ name: 'TrackPage' }">
                  <el-dropdown-item command="货物跟踪">{{
                    $t("header.menu.track")
                  }}</el-dropdown-item>
                </router-link>
                <!-- <router-link to="/incidentals">
								<el-dropdown-item command="口岸港杂费">口岸港杂费</el-dropdown-item>
							</router-link> -->
              </el-dropdown-menu>
            </el-dropdown>
          </div>
        </div>
        <div class="menu-item-container">
          <div
            :class="
              pathname == '/product/starList' ? 'menu-item active' : 'menu-item'
            "
          >
            <router-link to="/product/starList">
              <span class="el-dropdown-link area ">{{
                $t("header.menu.sales")
              }}</span>
            </router-link>
          </div>
        </div>
        <div class="menu-item-container">
          <div
            :class="
              about.includes(activePath) ? 'menu-item active' : 'menu-item'
            "
          >
            <router-link to="/yc">
              <span class="el-dropdown-link area ">{{
                $t("header.menu.about")
              }}</span>
            </router-link>
          </div>
        </div>
      </el-col>
      <el-col :span="2" class="item">
        <el-dropdown @command="handleLanguageCommand">
          <span class="el-dropdown-link" style="color:#67C23A">
            Language<i class="el-icon-arrow-down el-icon--right"></i>
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="en">English</el-dropdown-item>
            <el-dropdown-item command="zh">中文</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
        <!-- <el-button type="text" @click="gotoZhSite" style="color:#67C23A">中文版</el-button> -->
      </el-col>

      <el-col :span="4" class="item" :offset="0">
        <div v-if="!!login" class="logined">
          <el-dropdown :hide-on-click="false" class="nickname">
            <span class="el-dropdown-link name item item-r-border">
              <i class="iconfont el-icon-eft-user fl"></i
              ><span class="fl">{{
                !!user.nickname ? user.nickname : user.email
              }}</span>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item >
                <a
                  href="javascript:void(0)"
                  @click="logout()"
                  class="e-btn-logout"
                  >{{$t("header.menu.logout")}}</a>
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
        <div class="unlogined" v-else>
          <el-button type="text" class="btn-login fr" @click="accountLogin">{{
            $t("header.menu.login")
          }}</el-button>
          <el-button type="text" round class="btn-signup fr" @click="toRegister">{{
            $t("header.menu.register")
          }}</el-button>
        </div>
      </el-col>
    </div>
  </el-row>

  <el-row
    class="full-container header"
    v-else
    style="background-color:#fff; overflow:hidden;"
  >
    <div class="main-container">
      <img v-lazy="'//doc.yctop.com/images/static/saas/banner.jpg'" />
    </div>
  </el-row>
</template>
<script>
import UTILS from "@/utils/utils.js";
import YC_REQUEST_HANDLER from "@/api/request.js";
import { mapState, mapActions, mapGetters } from "vuex";
export default {
  data: function() {
    return {
      yunModel: this.$route.meta.yunModel,
      activePath: "",
      tool: ["tool", "track"],
      partner: ["partner", "contact"],
      about: ["yc", "start"],
      activity: ["brazil", "international", "hk"],
      pathname: ""
    };
  },
  watch: {
    $route: function() {
      let path = window.location.pathname;
      this.pathname = path;
      var pathArray = path.split("/");
      if (pathArray.length > 1) {
        this.activePath = pathArray[1];
      } else {
        this.activePath = "";
      }
    }
  },
  computed: {
    ...mapState({
      user: state => state.user,
      token: state => state.token
    }),
    ...mapGetters({
      login: "checkLogin"
    })
  },
  mounted: function() {
    var isChrome = navigator.userAgent.indexOf("Chrome") > -1;
    if (!isChrome) {
      var h = this.$createElement;
      this.$message({
        showClose: true,
        duration: 0,
        customClass: "v3-header-ie-msg",
        dangerouslyUseHTMLString: true,
        message:
          'Warm reminder from yctop.com: It is recommended to use the <b>Google</b> browser. For other browsers, please set the following <a href="/compatibility"><strong>settings</strong></a>'
      });
    }
  },
  methods: {
    toRegister:function(){
      this.$router.push("/user/register");
    },
    accountLogin: function() {
      this.$router.push('/user/login')
    },
    logout: async function() {
      let eftToken = window.localStorage.token;
      let { code } = await this.$store.dispatch("logout");
      if (eftToken) {
        try {
          await axios.get("/api-uc/yc/logout?token=" + eftToken);
          window.localStorage.removeItem("eftToken");
        } catch (err) {}
      }
      if (code == 200) {
        let requireAuth = this.$route.matched.some(
          record => record.meta.requiresAuth
        );
        if (requireAuth) {
          this.$router.push("/");
        } else {
          this.$message.success("Sign out successfully");
        }
      } else {
        this.$message.error("Sign out failed[" + code + "]");
      }
    },
    clearLocalStorage: function() {
      window.localStorage.clear();
      window.sessionStorage.clear();
    },
    gotoZhSite: ()=> {
      window.open('http://www.yctop.com', '_self')
    },
    handleLanguageCommand: function(command) {
      if(command == 'zh')
       this.gotoZhSite()
    }
  }
};
</script>
<style scoped>
@import "./index.css";
</style>
